import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterCard } from "~/components/Filters/FilterCard";
import { TypeFilter } from "~/components/Filters/TypeFilter/TypeFilter";
import { addItemTypeFilterAction, clearItemTypeFiltersAction, removeFilterAction, removeItemTypeFilterAction } from "~/store/filters/actions";
import { selectedItemTypesFiltersSelector } from "~/store/filters/selectors";
export const TypeFilterCard = /*#__PURE__*/ memo((param)=>{
    let { availableTypes, ...props } = param;
    const dispatch = useDispatch();
    const selectedTypes = useSelector(selectedItemTypesFiltersSelector);
    const clearValues = useCallback(()=>{
        dispatch(clearItemTypeFiltersAction());
    }, [
        dispatch
    ]);
    const onTypeSelectedChange = (type, isSelected)=>{
        if (isSelected) {
            dispatch(addItemTypeFilterAction({
                type
            }));
        } else {
            dispatch(removeItemTypeFilterAction({
                type
            }));
        }
    };
    const onRemoveFilter = (filter)=>{
        dispatch(removeFilterAction({
            filter
        }));
        clearValues();
    };
    return /*#__PURE__*/ _jsx(FilterCard, {
        currentFilter: "type",
        onClearClick: clearValues,
        onRemoveFilter: onRemoveFilter,
        ...props,
        children: /*#__PURE__*/ _jsx(TypeFilter, {
            availableTypes: availableTypes,
            onTypeSelectedChange: onTypeSelectedChange,
            selectedTypes: selectedTypes
        })
    });
});
TypeFilterCard.displayName = "TypeFilterCard";
